<template>
  <div class='h100vh-140'>
    <ejs-grid ref='grid' :dataSource='data' :allowReordering='true' :allowResizing='true' :allowExcelExport='true'
              :enableVirtualization='false' :enableColumnVirtualization='false'  :rowDeselected='getChooseCount' :rowSelected='getChooseCount'>
      <e-columns>
        <e-column field='neName' :headerText='$t("TS.neName")' textAlign='Center' width='5%'
                  clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='neID' :headerText='$t("TS.neID")' textAlign='Center' width='5%'
                  clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='taskName' :headerText='$t("TS.taskName")' :formatter='nameFormat' textAlign='Center' width='8%'
                  clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='taskDescription' :headerText='$t("TS.taskDetail")' :formatter='taskDescriberFormat' textAlign='Center' width='10%'
                  clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='taskState' :headerText='$t("TS.taskState")' textAlign='Center' width='10%'
                  clipMode='EllipsisWithTooltip' :formatter='stateFormat' :customAttributes="customAttributes" :disableHtmlEncode='false' ></e-column>
        <e-column field='startTime' :headerText='$t("TS.opTime")' textAlign='Center' width='5%'
                  clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='operation' :headerText='$t("TS.operation")' textAlign='Center' width='5%'
                  clipMode='EllipsisWithTooltip' :template='cTemplate'></e-column>

      </e-columns>
    </ejs-grid>
    <ejs-pager ref='pager' @click='getTaskListData()' :currentPage='page.pageNo' :pageSize='page.pageSize'
               :totalRecordsCount='page.totalCount' :pageCount='page.pageCount'></ejs-pager>

  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { GridPlugin, Reorder, Resize, ExcelExport, ContextMenu } from '@syncfusion/ej2-vue-grids';
import TaskOperButton from './TaskOperButton';
import socketInstance from '../../../../plugins/stompSock.js';
import { EventBus } from '../../../../plugins/eventBus';

Vue.use(GridPlugin);

export default {
  name: 'TaskTable',
  data() {
    return {
      data: {},
      neIds: [],
      taskId: '',
      customAttributes: {},
      page: {
        pageNo: 1,
        pageSize: 100,
        totalCount: 0,
        pageCount: 100
      },
      payload: [
        { topic: '/user/#/TSTaskServer', clientId: '', callback: this.subscribeCallback }
      ],
      cTemplate() {
        return { template: TaskOperButton };
      },
      selectOptions: { type: 'Multiple' }
    };
  },
  provide: {
    grid: [Reorder, Resize, ExcelExport, ContextMenu]
  },
  methods: {
    websocketConnect() {
      // const oldClientId = this.payload[0].clientId;
      if(this.taskId !== '' && this.taskId !== undefined){
        this.payload[0].clientId = this.taskId;
        if (socketInstance.stompClient == null) {
          socketInstance.init(this.payload);
        } else {
          /* if (oldClientId !== '' && oldClientId !== 'undefined') {
            socketInstance.stopReceiveTopicMsg(oldClientId, '/user/#/TSTaskServer');
          } */
          socketInstance.dynamicSubscribe('/user/#/TSTaskServer', this.taskId, this.subscribeCallback);

        }
      }
    },
    subscribeCallback(msg) {
      console.log(msg);
      const data = JSON.parse(msg.body);
      const response = data.resultVal.responseData;
      if (response.errorCode !== 0) {
        EventBus.$emit('toast', { type: 'success', content: this.$t('Common.tips.success') });
      } else {
        EventBus.$emit('toast', { type: 'error', content: response.errorCode });
      }
    },
    nameFormat(grids, data) {
      if (data.taskName === 'Call Collection') {
        return `${this.$t('TS.ts_call_task_name')}`;
      }
      if (data.taskName === 'Reg Collection') {
        return `${this.$t('TS.ts_reg_task_name')}`;
      }
      return data.taskName;
    },
    taskDescriberFormat(grids, data) {
      if (data.taskDescription === 'Call Information Reporting') {
        return `${this.$t('TS.ts_call_task_describer')}`;
      }
      if (data.taskDescription === 'Reg Information Reporting') {
        return `${this.$t('TS.ts_reg_task_describer')}`;
      }
      return data.taskDescription;
    },
    stateFormat(grids, data) {
      return `<span class='h-ts-rowcell${data.taskState}'>${this.$t(`TS.taskState_${data.taskState}`)}</span>`;
    },
    getTaskListData() {
      // 获取表格数据
      const This = this;
      This.$axios.post(`/lte/ems/ts/getTaskList.html?neIds=${This.neIds}`, {
        page: {
          pageNo: This.page.pageNo,
          pageSize: This.page.pageSize
        }
      }).then((response) => {
        This.data = response.data.resultVal.result;
        This.page.totalCount = response.data.resultVal.totalCount;
      });
    },
    getChooseCount() {
      this.getTaskListData();
    },
    getNeListByAuth() {
      const This = this;
      // TYPE_MC_PF(16, "mc_pf", 123),
      // TYPE_TCF(8, "tcf", 106),
      // todo const nodeTypeCodes = [16]; 等调试完把注释放开
      const nodeTypeCodes = [8, 16];
      this.$axios.post('/lte/ems/auth/findElementListByAuth', nodeTypeCodes).then((response) => {
        if (response && response.status === 200) {
          for (let i = 0; i < response.data.length; i++) {
            This.neIds.push(response.data[i].id);
          }
          this.getTaskListData();
        }
      });
      this.getTaskListData();
    }
  },
  beforeMount() {
    this.getNeListByAuth();
  }
};
</script>
<style>
</style>
